import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Store} from '@ngrx/store';
import {createEffect, Actions, ofType} from '@ngrx/effects';

import {map, switchMap, tap, catchError, mergeMap} from 'rxjs/operators';
import {of} from 'rxjs';

import * as DemoActions from './demo.actions';
import * as ErrorActions from '../../error/store/error.actions';
import {HttpErrorResponse} from '@angular/common/http';
import {DemoService} from '../demo.service';
import {Demo} from '../demo.model';
import {Profile} from '../../profile/profile.model';
import * as ProfileActions from '../../profile/store/profile.actions';
import * as fromApp from '../../store/app.reducers';
import {ToastrService} from 'ngx-toastr';

@Injectable()
export class DemoEffects {

  getAudit = createEffect(() => this.actions$
    .pipe(
      ofType(DemoActions.GET_DEMO),
      map(
        (data: {type: string, payload: { id: string, saveAsDemo: boolean }}) => {
          return data.payload;
        }
      ),
      mergeMap(
        (params: {id: string, saveAsDemo: boolean}) => {
          return this.demoService.getDemo(params.id).pipe(
            mergeMap(
              (response: Demo) => {
                const payloads = [];
                let actions: any;
                if (!params.saveAsDemo) {
                  actions = ProfileActions;
                } else {
                  actions = DemoActions;
                }

                if (response.status !== 3) {
                  response.credentials.profileDetail.demo = 1;
                  payloads.push({
                    type: actions.SET_AUDIT,
                    payload: response.credentials.audit
                  });
                  payloads.push({
                    type: actions.SET_MEDIA_ANALYZE,
                    payload: response.credentials.mediaAnalyze
                  });
                  payloads.push({
                    type: actions.SET_PROFILE_DETAIL,
                    payload: response.credentials.profileDetail
                  });
                  payloads.push({
                    type: actions.SET_PROFILE_PROGRESS,
                    payload: response.credentials.profileProgress
                  });
                  payloads.push({
                    type: actions.SET_FOLLOWER_ENGAGE,
                    payload: response.credentials.followerEngage
                  });
                }

                payloads.push(...[{
                  type: actions.SET_AUDIENCE_INTEREST,
                  payload: response.credentials.audienceInterest
                }, {
                  type: actions.SET_AUDIENCE_LOCATION,
                  payload: response.credentials.audienceLocation
                }, {
                  type: actions.SET_AUDIENCE_STAT,
                  payload: response.credentials.audienceStat
                }, {
                  type: actions.SET_FOLLOWER_ENGAGE_INDICATOR,
                  payload: response.credentials.followerEngageIndicator
                }, {
                  type: actions.SET_FOLLOWER_STAT,
                  payload: response.credentials.followerStat
                }, {
                  type: actions.SET_MEDIA_COMMENT_ANALYZE,
                  payload: response.credentials.mediaCommentAnalyze
                }, {
                  type: actions.SET_MEDIA_STAT,
                  payload: response.credentials.mediaStat
                }, {
                  type: actions.SET_PROFILE_SCORE,
                  payload: response.credentials.score
                }, {
                  type: actions.SET_CHARTS_RELOAD,
                  payload: actions.SET_AUDIENCE_INTEREST
                }, {
                  type: actions.SET_CHARTS_RELOAD,
                  payload: actions.SET_AUDIENCE_LOCATION
                }, {
                  type: actions.SET_CHARTS_RELOAD,
                  payload: actions.SET_AUDIENCE_STAT
                }, {
                  type: actions.SET_CHARTS_RELOAD,
                  payload: actions.SET_FOLLOWER_ENGAGE_INDICATOR
                }, {
                  type: actions.SET_CHARTS_RELOAD,
                  payload: actions.SET_FOLLOWER_STAT
                }, {
                  type: actions.SET_CHARTS_RELOAD,
                  payload: actions.SET_MEDIA_ANALYZE
                }, {
                  type: actions.SET_CHARTS_RELOAD,
                  payload: actions.SET_MEDIA_COMMENT_ANALYZE
                }, {
                  type: actions.SET_CHARTS_RELOAD,
                  payload: actions.SET_MEDIA_STAT
                }, {
                  type: actions.SET_CHARTS_RELOAD,
                  payload: actions.SET_FOLLOWER_ENGAGE
                }]);

                return payloads;
              }
            ),
            catchError(
              (err: HttpErrorResponse) => {
                return of({
                  type: ErrorActions.SET_HTTP_ERROR,
                  payload: err
                });
              }
            )
          );
        }
      )
    ), {dispatch: true}
  );

  getAudits = createEffect(() => this.actions$
    .pipe(
      ofType(DemoActions.GET_DEMO_LIST),
      map(
        (data: {type: string, payload: number}) => {
          return data.payload;
        }
      ),
      switchMap(
        (type: number) => {
          this.store.dispatch(
            new ProfileActions.SetLoader({module: 'auditList', box: 'list', value: false})
          );
          return this.demoService.getDemoList(type).pipe(
            mergeMap(
              (response: Profile[]) => {
                // if (response.length === 1) {
                //   this.router.navigate(['audit', response[0].id]);
                // }
                return [{
                  type: DemoActions.SET_DEMO_LIST,
                  payload: response
                }, {
                  type: ProfileActions.SET_LOADER,
                  payload: {module: 'auditList', box: 'list', value: true}
                }];
              }
            ),
            catchError(
              (err: HttpErrorResponse) => {
                return of({
                  type: ErrorActions.SET_HTTP_ERROR,
                  payload: err
                });
              }
            )
          );
        }
      )
    ), {dispatch: true}
  );

  addDemo = createEffect(() => this.actions$
    .pipe(
      ofType(DemoActions.ADD_DEMO_AUDIT),
      map(
        (data: {type: string, payload: Demo}) => {
          return data.payload;
        }
      ),
      switchMap(
        (demo: Demo) => {
          return this.demoService.createDemo(demo.type, demo.status, demo.credentials).pipe(
            tap(
              (response: Demo) => {
                this.notifierService.success('The report has been added!');
              }
            ),
            catchError(
              (err: HttpErrorResponse) => {
                return of({
                  type: ErrorActions.SET_HTTP_ERROR,
                  payload: err
                });
              }
            )
          );
        }
      )
    ), {dispatch: false}
  );

  constructor(
    private actions$: Actions,
    private demoService: DemoService,
    private notifierService: ToastrService,
    private router: Router,
    private store: Store<fromApp.AppState>

  ) {}
}
